import { shape, string, number } from 'prop-types';

export const orgJob = shape({
  id: string,
  name: string,
  employeeCount: number,
  description: string,
  code: string,
  codeKey: string,
  currency: string
});
